import React from 'react';
import PropTypes from 'prop-types';
import { useBreakpoint } from '@app/hooks';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconInfo } from '@blocks-react/components/Icons/Info';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { CatToast } from '@blocks-react/components/Toast';
import { CatToastGroup } from '@blocks-react/components/ToastGroup';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import styles from './CustomCartToast.module.scss';

const CustomCartToast = ({ toastStatus, toastContent, handleToastClose }) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  return (
    <CatToastGroup
      verticalPosition="top"
      horizontalPosition="center"
      className={styles['custom-toast']}
    >
      <React.Fragment key=".0">
        <CatToast
          autoClose={true}
          dismissible={true}
          className={`${isMD ? '' : styles['toast-sm-width']}`}
          variant={toastStatus === 'error' ? 'error' : 'success'}
          onBlToastClose={handleToastClose}
          onBlToastCancel={handleToastClose}
        >
          {toastStatus === 'error' ? (
            <CatIconInfo slot="before" />
          ) : (
            <CatIconSuccess slot="before" />
          )}
          <CatHeading variant="label">{toastContent}</CatHeading>
        </CatToast>
      </React.Fragment>
    </CatToastGroup>
  );
};

CustomCartToast.propTypes = {
  toastStatus: PropTypes.string,
  toastContent: PropTypes.string,
  handleToastClose: PropTypes.func
};
export default CustomCartToast;
